import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Content from "../../../components/layout/Content";
import InventoryList from "./InventoryList";
import { useDispatch, useSelector } from "react-redux";
import { fetchInventoryForms } from "../../../action";
import ErrorContainer from "../../../components/utils/ErrorContainer";
import HeadMobileActionMenu from "../../../components/utils/HeadMobileActionMenu";
import { isEmpty } from 'lodash';
import { fetchFilials } from '../../../action/handbook';
import { fetchSettings } from '../../../action/app';
import swal from "sweetalert";

const Inventory = (props) => {
    const { history } = props;
    const dispatch = useDispatch();
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const settings = useSelector(state => state.settings.init);

    useEffect(() => {
        if (isEmpty(points) || points.length < pointsCount) dispatch(fetchFilials(null, true));
        if (isEmpty(settings)) dispatch(fetchSettings());
        dispatch(fetchInventoryForms());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const onRefresh = () => {
        dispatch(fetchFilials(false, true));
        dispatch(fetchInventoryForms());
        dispatch(fetchSettings());
    };

    const openForm = () => {
        if (!isEmpty(settings) && !settings.enableConsumption) {
            return swal({
                title: 'Создание инвентаризации невозможно',
                text: '"Списание сырья" отключено',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        } else {
            history.push('/accounting/inventory/form');
        }
    }

    const actionsMobile = [
        { name: 'Добавить инвентаризацию', icon: 'flaticon2-plus', action: () => openForm() },
    ];

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Инвентаризации</h3>
                    </div>
                    <div className="kt-subheader__toolbar">
                        {window.innerWidth > 1024 && (
                            <>
                                <button
                                    className="btn btn-success btn-icon-sm"
                                    onClick={openForm}>
                                    Добавить инвентаризацию
                                </button>
                            </>
                        )}
                        <button onClick={onRefresh} className="btn btn-secondary btn-icon">
                            <i className="la la-refresh"></i>
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Content>
            <HeadMobileActionMenu actions={actionsMobile}/>
            {renderSubHeader()}
            <ErrorContainer field='inventoryForms' hasCloseButton={true} style={{ margin: 25 }}/>
            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                    <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                        <InventoryList points={points} onRefresh={onRefresh}/>
                    </div>
                </div>
            </div>
        </Content>
    );
};

export default withRouter(Inventory);
